import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import { message } from 'antd'
import 'antd/dist/antd.css'
import "assets/css/normalize.css"
import 'assets/css/response.scss'
import 'assets/css/reset_antd.scss'
import './index.scss'
import App from './App'
import { $getGoods } from 'service/recharge'
import { $affVisit } from 'service/affiliate'
import { isAuthTimeout, isLogined, $userInfo, getCallingCode } from 'service/sign'
import { refreshUnreadStatus } from 'service/notification'
import { getSearch } from 'utils/utils'

message.config({ maxCount: 5, duration: 5 })
ReactDOM.render(<App />, document.getElementById('root'))

// 获取商品列表
$getGoods()

// 每次刷新判断是否登录过期
isAuthTimeout()

// 如果用户已登录，刷新用户信息
if (isLogined() && getSearch('login-token') == null) {
  $userInfo()
  refreshUnreadStatus()
}


// 获取手机区号选择
getCallingCode()

//aff统计
const affStatistics = async () => {
  if (getSearch('affiliate-code') && !sessionStorage.affStatistics) {
    await $affVisit(getSearch('referrer') ? getSearch('referrer') : document.referrer || '', getSearch('affiliate-code'))
    sessionStorage.setItem('affStatistics', 'true')
  }
}
affStatistics()

//获取当前所使用的人机验证方式
// verifyMode()